<template>
    <div class="element-wrapper" :class="{'is_error': is_error}">
        <div class="element-title">
                <h3 v-text="title"></h3>
                <i class="icon" :class="{'icon-exclaim':is_error }"></i>                
            </div>
        <div class="element-content">
            <div class="element-for-show">   
                <div @click="showPopup" class="no-value" v-text="label" v-show="!value.length"></div>
                <div @click="showPopup" class="have-value" v-text="value" v-show="value.length"></div>
            </div>    
        </div>
        <van-popup v-model:show="show" position="bottom">
            <van-date-picker
                :maxDate="new Date()"
                :minDate="new Date(1960, 0, 1)"
                @confirm="confirm"
                @cancel="cancel"
            />
        </van-popup>
    </div>
</template>
<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
// import { DatePicker, Cell, Popup } from 'vant'
export default {    
    props:{
        value:{
            type:String
        },
        title:{
            type:String
        },
        keys:{
            type:String
        },
        checkType:{
            type:String
        },
        maxlength:{
            type:Number,
            default: 5
        },
        label:{
            type:String
        },
        is_error:{
            type:Boolean
        },
        is_show:{
            type:Boolean
        },
        component_id:{
            type:Number
        },
        eventCount:{
            type:Number
        },
        fromPage:{
            type:String
        },
        requestId:{
            type:String
        },
    },
    setup (props, { emit }) {
        const show = ref(false)
        const selected_ind = ref(0)
        const selected = (ind) => {
            selected_ind.value = ind
        }
        const store = useStore()
        const showPopup = () =>{
            show.value = true;    
            try {
                emit('modify', 
                    props.component_id,
                    true,
                    "",
                    props.requestId,
                    store.state.buryConfig[props.fromPage][props.keys]['focus']
                )    
            } catch (error) {
                console.log(error)
            }        
        } 
        const cancel = () => {
            show.value = false;
            try {
                emit('modify', 
                    props.component_id,
                    false,
                    "",
                    props.requestId,
                    store.state.buryConfig[props.fromPage][props.keys]['complete']
                )    
            } catch (error) {
                console.log(error)
            }
        }
        const confirm = (v) => {
            let { selectedValues  } = v
            show.value = false;
            console.log(selectedValues.join("-"));
            emit("setValue", props.keys, selectedValues.join("-"))
            try {
                emit('modify', 
                    props.component_id,
                    false,
                    selectedValues.join("-"),
                    props.requestId,
                    store.state.buryConfig[props.fromPage][props.keys]['complete']
                )    
            } catch (error) {
                console.log(error)
            } 
        }
       
        return {
            show,
            showPopup,
            confirm,
            cancel,
            selected_ind,
            selected,       
        }
    }
}
</script>
<style lang="less" scoped>

.element-wrapper{
    padding-bottom: 30px;
    border-bottom: 2px solid #EFEEF1;
    position: relative;
    margin-bottom: 30px;
    &.is_error{
        border-bottom:  2px solid #C5340B;       
    }
    .element-title{
        color:#73698F;
        font-size: 26px;  
        overflow: hidden;
        padding:15px 0;      
        h3{
            float:left;
        }
        .icon-exclaim{
            float:left;
            margin-left: 20px;
        }
        .icon-arrow-down{
            float:right
        }
    }
    .element-content{
        margin-top: 30px;
        color:#000;
        font-size: 36px;
        height:40px;
        line-height: 40px;
        .element-for-show{
            display:block;
            width: 100%;
            font-size: 32px;
            border:none;
            .no-value{
                color:#D0CDDA;
            }   
            .have-value{
                color:#00BE82;
            }         
        }
    }
}
</style>